import URLS from '@utils/urlList';

import axios from 'axios';

export const getEspot = (hostname: string, storeId: string, espotName: string) => {
    return new Promise((resolve, reject) => {
        const url =
            hostname +
            URLS.GET_ESPOT.replace('##storeId##', storeId) +
            espotName +
            '?nocache=' +
            new Date().getTime();

        if (url) {
            axios({
                url,
                method: 'GET',
                withCredentials: true,
            })
                .then((response: any) => {
                    let res =
                        response?.data?.MarketingSpotData?.[0]?.baseMarketingSpotActivityData?.[0]
                            ?.marketingContentDescription?.[0]?.marketingText;
                    resolve(res);
                })
                .catch((err: any) => {
                    reject(err.response);
                });
        }
    });
};
